import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";
import SurveyReportLayout from "./SurveyReportLayout";
import axiosInstance from "../../../../Services/axiosCommon";
import CommonDynamicForm from "../../../../Components/Utils/CommonDynamicForm";
import { useParams } from "react-router-dom";
import { useToast } from "../../../../Components/Others/ToastServices";
import NuDate from "../../../../Components/Utils/NuDate";
import EditIcon from "../../../../Components/Icons/Edit";

function FormSurvey() {
  const { surveyReportViewId } = useParams();
  const [editModeIndex, setEditModeIndex] = useState(null);

  const toast = useToast();

  const [allFormValues, setAllFormValues] = useState([]);
  const [allForm, setAllForm] = useState([]);
  const [allValue, setAllValue] = useState([]);
  useEffect(() => {
    if (surveyReportViewId) fetchTasks(surveyReportViewId);
  }, [surveyReportViewId]);

  const fetchTasks = async (value) => {
    try {
      const response = await axiosInstance.get(
        `/survey-report/get-form/${value}`
      );
      const data = response.data?.data;
      console.log("TEST ONE - Data", data);

      if (Array.isArray(data)) {
        setAllFormValues(data);
      } else if (data) {
        setAllFormValues([data]);
      } else {
        setAllFormValues([]);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setAllFormValues([]);
    }
  };

  const [formId, setFormId] = useState(null);

  const fetchAllForm = async (value) => {
    setFormId(value);
    try {
      // setLoading(true);
      const formResponse = await axiosInstance.get(
        `/survey-report/get-form/${value}`
      );
      console.log(formResponse.data?.data);
      setAllForm(formResponse.data?.data);
      let TempArray = [];
      let tempFormData = formResponse.data?.data?.titles || [];
      tempFormData?.forEach((item) => {
        item?.fields?.forEach((field) => {
          console.log("Field - getting", field);
          let ValueInSide = {
            id: field?.id,
            field_type: field?.field_type,
            value: field?.value,
          };
          TempArray.push(ValueInSide);
        });
      });
      setAllValue(TempArray);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      // setLoading(false);
    }
  };

  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index, id) => {
    setAllForm([]);
    fetchAllForm(id);
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validationSchema: yup.object({}),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      let ValuesForForm = {
        isSubmitted: true,
        values: allValue,
      };
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(ValuesForForm));
      axiosInstance
        .put(`/surveyInspectionForm/SIforms/${formId}`, formData)
        .then((res) => {
          console.log("Form Submitted", res.data);
          if (res.data?.status === true) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Created Successfully.",
            });
            CloseEditForm(formId)

          } else {
            toast.open({
              type: "error",
              message: "Error",
              description: res.data?.msg || "Network error.",
            });
          }
        });
    },
  });

  function SaveFormData() {
    let ValuesForForm = {
      isSubmitted: false,
      values: allValue,
    };
    let formData = new FormData();
    formData.append("json_data", JSON.stringify(ValuesForForm));
    axiosInstance
      .put(`/surveyInspectionForm/SIforms/${formId}`, formData)
      .then((res) => {
        console.log("Form Submitted", res.data);
        if (res.data?.status === true) {
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
          CloseEditForm(formId)

        } else {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      });
  }

 async function CloseEditForm(id) {
    await axiosInstance.put(`/surveyInspectionForm/close-form/${surveyReportViewId}`).then(res=>{
      console.log("eeeee",res?.data?.status);
      
      if(res?.data?.status){
        console.log("ok");
        setEditModeIndex(null)
        fetchTasks(surveyReportViewId)
      }else{
        console.log("error");
        toast.open({
          type: "error",
          message: "Error",
          description: res.data?.msg || "Network error.",
        });
      }
    }).catch(error=>{
      toast.open({
        type: "error",
        message: "Error",
        description: error?.response?.data?.msg || "Network error.",
      });
    }) 
  }

  async function OpenEditForm(index,id,workingUser){
    if(workingUser){
      CloseEditForm(id)
    }else{
      await axiosInstance.put(`/surveyInspectionForm/open-form/${surveyReportViewId}`).then(res=>{
        console.log("eeeee",res?.data?.status);
        
        if(res?.data?.status){
          fetchTasks(surveyReportViewId)
          setEditModeIndex(
            editModeIndex === index ? null : index
          )
        }else{
          console.log("error");
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      }).catch(error=>{
        toast.open({
          type: "error",
          message: "Error",
          description: error?.response?.data?.msg || "Network error.",
        });
      })
    }    
  }

  return (
    <SurveyReportLayout>
      <div className="w-full h-full mt-0.5 overflow-y-auto">
        {
          <div className="w-full mx-auto h-[calc(100vh-175px)] overflow-y-scroll bg-white rounded-lg shadow-md pb-8">
            {allFormValues?.map((item, index) => {
              return (
                <>
                  <div
                    key={item?.id || index}
                    className="border-b border-gray-300"
                  >
                    <div
                      className="flex justify-between items-center p-2 cursor-pointer bg-slate-50 "
                      // onClick={() => handleToggle(index, item?.id)}
                    >
                      <h1 className="text-sm font-semibold w-[30%]">
                        {item.formName || " - "}
                      </h1>
                      <div className="flex gap-6 items-center w-[70%] justify-end mr-1">
                      {item?.workingUser != null && (
                          <div className=" flex items-center py-1 overflow-hidden rounded-lg text-[10px] 2xl:text-xs  w-[25%] ">
                            <div className=" py-1 h-10 bg-white px-1 rounded-s-lg font-medium flex items-center border border-emerald-300">
                              Working User{" "}
                            </div>
                            <div className=" py-1 h-10 bg-emerald-300 text-white font-medium px-1 rounded-e-lg flex items-center">
                              {item?.workingUserName || "No User"}
                            </div>
                          </div>
                        )}
                        <div className=" flex items-center py-1 overflow-hidden rounded-lg text-[10px] 2xl:text-xs w-[25%] ">
                        <div className=" py-1 h-10 bg-white px-1 rounded-s-lg font-medium flex items-center border border-blue-400">
                            Updated By{" "}
                          </div>
                          <div className=" py-1 h-10 bg-blue-400 text-white font-medium px-1 rounded-e-lg flex items-center">
                            {item?.updatedByName || " No User"}
                          </div>
                        </div>
                        <div className=" flex items-center py-1 overflow-hidden rounded-lg text-[10px] 2xl:text-xs  w-[20%] ">
                        <div className=" py-1 h-10 bg-white px-1 rounded-s-lg font-medium flex items-center border border-green-400">
                            Status{" "}
                          </div>
                          <div className=" py-1 h-10 bg-green-400 text-white font-medium px-1 rounded-e-lg flex items-center">
                            {item?.status || "Yet To Start"}
                          </div>
                          
                        </div>
                        <div className=" flex  items-center py-1 overflow-hidden rounded-lg text-[10px] 2xl:text-xs  w-[25%] ">
                                                 <div className=" py-1 h-10 bg-white  px-1 rounded-s-lg font-medium flex items-center border border-yellow-400">
                                                   Completion Date{" "}
                                                 </div>
                                                 <div className=" py-0.5 h-10 bg-yellow-400 px-1 text-white rounded-e-lg flex flex-col justify-center font-medium ">
                                                   <div className=" text-[10px] line-clamp-1">
                                                     {" "}
                                                     <NuDate
                                                       value={item?.dateTime}
                                                       format="DD-MM-YYYY"
                                                     />
                                                   </div>
                                                   <div className=" text-[9px]">
                                                     <NuDate value={item?.dateTime} format="hh:mm a" />
                                                     
                                                   </div>
                                                 </div>
                                               </div>
                      </div>
                      <span
                        onClick={() =>OpenEditForm(index,item?.id,item?.workingUser)}
                        className="cursor-pointer mr-4"
                      >
                        <EditIcon
                          color={editModeIndex === index ? "green" : "red"}
                          height={12}
                        />
                      </span>

                      <span onClick={() => handleToggle(index, surveyReportViewId)}>
                        {expandedIndex === index ? (
                          <ToggleUp />
                        ) : (
                          <ToggleDown />
                        )}
                      </span>
                    </div>
                  </div>
                  {expandedIndex === index && (
                    <form onSubmit={formik.handleSubmit}>
                      <CommonDynamicForm
                        formData={allForm?.titles || []}
                        formik={formik}
                        expandedIndex={expandedIndex}
                        index={index}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        SaveFormData={SaveFormData}
                        editModeIndex={editModeIndex}
                      />
                    </form>
                  )}
                </>
              );
            })}
          </div>
        }
      </div>
    </SurveyReportLayout>
  );
}

export default FormSurvey;
